module.exports = __webpack_public_path__ + "media/images/background-photo-3@1x-06f11b9583b0e8ce27ef119d51b0cd81.png";